import React, { useContext, useEffect, useState ,memo,useMemo } from "react";
import ReactDOM from "react";

//import Controls from "./components/controls";


//import 'zrender/lib/vml/vml';
import { BasicContext } from '../../../context/BasicContext'
import WebServiceContext from '../../../webService/WebServiceContext'

import Menu from "../Menu";

import ChartCard from './ChartCard'

import {Loading} from '../../SVG'


type SubMenuListProps = {
    CName: string
    Groupid: string
    TabName: string
}



let sURL = new URL(window.location.href);
sURL.searchParams.get('pid');


/*
const options = {
    width: 200,
    height: 100,
    tooltips: { enabled: false },
    rotation: -90,
    //circumference: 180,
    //maintainAspectRatio: false
}*/

type MixChartProps = {
    tabName: string
}


export default (props:MixChartProps) => {
    const bc = useContext(BasicContext)
    const ws = useContext(WebServiceContext)
    const [cardData, setCardData] = useState<MixChart.CardDataProp[]>([])
    const [managerData, setManagerData] = useState<MixChart.ManagerDataProp[]>([])
    const [subMenu, setSubMenu] = useState<SubMenuListProps[]>([])

    const [currentGroupID, setCurrentGroupID] = useState<string>("")

    const getMenuContent = (id: string) => {
        setCardData([])//先清空

        //20231128 以下分類要分別撈不同的SP
        if(props.tabName == "綜合圖表"){
            ws.webservice.asyncMenuContentReader("Dashboard_GetData", id).then(res => {
                const cdps: MixChart.CardDataProp[] = res as MixChart.CardDataProp[]
                setCardData(cdps)

            })
           
        }
    }

    const loadContent =()=>{
        ws.webservice.asyncMenuChecker().then(res => {
            const sml: SubMenuListProps[] = tabNameFilter(props.tabName, res as SubMenuListProps[])
            console.log(sml)
            //新增過濾分類
            setSubMenu(sml)
            if (sml.length > 0) {
                //setCurrentGroupID(sml[0].Groupid)
                getMenuContent(sml[0].Groupid)
            }

        })
    }

    useEffect(() => {
        loadContent()
        return
    }, [bc.PID])

    const tabNameFilter = (filterStr:string, source:SubMenuListProps[]):SubMenuListProps[]=>{
        let resList:SubMenuListProps[] = [];
        source.map((item:SubMenuListProps)=>{
            if(item.TabName == filterStr){
                resList.push(item)
            }
        })
        return resList;
    }

    const sMenuHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setCardData([])
        setCurrentGroupID(event.target.value as string)
        getMenuContent(event.target.value as string)
    }

    //const MemoChartCard = memo(ChartCard )

    return (
        <>
            <div className="dashboard-header">
                <div className="btns">
                    <Menu />
                </div>
                <div className="right">

                    <button 
                        className="hibBtn main"
                        onClick={()=>{
                            //loadContent()
                            getMenuContent(currentGroupID)
                        }}
                    >重新整理</button>
                </div>
            </div>
            {
                subMenu.length > 0 &&
                <select className="hibSelect" onChange={sMenuHandler}>
                    {
                        subMenu.map((item: SubMenuListProps) =>
                            <option value={item.Groupid} key={"sMenu_" + item.Groupid}>
                                {item.CName}
                            </option>
                        )
                    }
                </select>
            }
           
            <div className="cardsContainer" style={{ display: "flex" }}>
                {
                    cardData && cardData.length >0 ?
                    cardData.map((cdp: MixChart.CardDataProp , index:number) => {
                        return (
                            <ChartCard
                                key={"cCard_" + index}
                                data={cdp}
                            />
                        )
                    })
                    /*:
                    managerData && managerData.length > 0 ?
                        <ProductsRank mdata={managerData}/>
                    
                   
                    :*/:
                    <>
                        <Loading/>
                    </>
                }
            </div>

        </>
    )

};
